var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCinemaClapboardSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_6234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7859 8.69178L45.36 9.60922L48.2526 2.10266L50.407 1.5237L50.2423 0.896851L0 14.3634L1.35501 19.4116L3.39031 14.1241L6.81291 13.2033L3.9214 20.7121L1.84602 21.2688L2.01192 21.8956L52.252 8.42902L50.8713 3.27174L48.7859 8.69178ZM7.97864 19.6254L10.8701 12.1166L14.2961 11.1958L11.3834 18.7102L7.97864 19.6254ZM15.4607 17.6257L18.35 10.1136L21.7592 9.20172L18.8677 16.7094L15.4607 17.6257ZM22.9383 15.6171L25.832 8.10836L29.239 7.19314L26.3453 14.7019L22.9383 15.6171ZM30.4126 13.613L33.3063 6.10646L36.7155 5.19458L33.8274 12.7L30.4126 13.613ZM37.8824 11.6122L40.7928 4.10011L44.2021 3.18266L41.3039 10.6948L37.8824 11.6122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7711 29.0481L47.0336 22.5459H50.5776L54.0002 27.24V21.8956H1.98647V22.5459H4.13533L8.87063 29.0481H5.32556L1.98535 24.4642V53.1032H54.0002V29.0481H51.7711ZM13.0737 29.0481L8.33842 22.5459H11.8646L16.6199 29.0481H13.0737ZM20.8185 29.0481L16.0821 22.5459H19.6083L24.3458 29.0481H20.8185ZM28.5656 29.0481L23.827 22.5459H27.3486L32.0895 29.0481H28.5656ZM36.306 29.0481L31.5662 22.5459H35.089L39.8288 29.0481H36.306ZM44.0541 29.0481L39.2955 22.5459H42.8394L47.578 29.0481H44.0541Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_6234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinemaClapboardSvgrepoCom1);
export default __webpack_public_path__ + "static/media/cinema-clapboard-svgrepo-com 1.9ff4be9da130ec0940b1b8345c310d99.svg";
export { ForwardRef as ReactComponent };